import * as React from "react";
const SvgUsers = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M8.25 12C10.7767 12 12.8333 9.94418 12.8333 7.41668C12.8333 4.88918 10.7767 2.83334 8.25 2.83334C5.72333 2.83334 3.66667 4.88918 3.66667 7.41668C3.66667 9.94418 5.72333 12 8.25 12ZM16.1667 12C18.4642 12 20.3333 10.1308 20.3333 7.83334C20.3333 5.53584 18.4642 3.66668 16.1667 3.66668C15.2642 3.66668 14.4333 3.96251 13.7508 4.45168C14.2283 5.33501 14.5 6.34418 14.5 7.41668C14.5 8.72084 14.0975 9.93251 13.4117 10.935C14.1483 11.59 15.1067 12 16.1667 12ZM15.75 13.6667C15.3367 13.6667 14.9325 13.6975 14.5417 13.7525C16.0658 14.86 17 16.4067 17 18.1458V21.1667H22V18.1458C22 15.6758 19.1967 13.6667 15.75 13.6667ZM8.66667 13.6667C4.99083 13.6667 2 15.6758 2 18.1458V21.1667H15.3333V18.1458C15.3333 15.6758 12.3433 13.6667 8.66667 13.6667Z",
	fill: "#616161"
}));
export default SvgUsers;
